"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.globalFonts = exports.GlobalStyle = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = require("styled-components");

var _templateObject, _templateObject2;

var globalFonts = (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  * {\n    font-family: ", ", sans-serif;\n    letter-spacing: 0.25px;\n  }\n  body {\n    font-size: ", "px;\n    color: ", ";\n    background-color: ", ";\n    ", ";\n  }\n"])), function (props) {
  return props.theme.typography.baseFontFamily;
}, function (props) {
  return props.theme.typography.baseFontSize;
}, function (props) {
  return props.theme.palette.text.tertiary;
}, function (props) {
  return props.theme.palette.background.tertiary;
}, function (props) {
  return props.theme.typography.fontFamily.regular;
});
exports.globalFonts = globalFonts;
var GlobalStyle = (0, _styledComponents.createGlobalStyle)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n ", ""])), globalFonts);
exports.GlobalStyle = GlobalStyle;